var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConciergeExclamation = function SvgConciergeExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "concierge--exclamation_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 160 100",
    style: {
      enableBackground: "new 0 0 160 100"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".concierge--exclamation_svg__st0,.concierge--exclamation_svg__st1{fill:none;stroke:#0b1b34;stroke-width:2;stroke-miterlimit:10}.concierge--exclamation_svg__st1{fill:#0185ff;stroke:#fff}.concierge--exclamation_svg__st2{fill:#0b1b34}.concierge--exclamation_svg__st5{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113 46.7v7.9",
    className: "concierge--exclamation_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.2 72c.1-11.1-10.8-20.2-24.2-20.2s-24.3 9-24.2 20.2h48.4z",
    className: "concierge--exclamation_svg__st1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.6 66.1c-1.6-3.4-4.7-6.2-8.5-8l8.5 8z",
    className: "concierge--exclamation_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.6 66.1c-1.6-3.4-4.7-6.2-8.5-8",
    style: {
      fill: "none",
      strokeLinecap: "round",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.3 47.7c0-2-2-3.6-4.4-3.6s-4.4 1.6-4.4 3.6h8.8z",
    className: "concierge--exclamation_svg__st2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9 79H85l3.7-6.9h48.5l3.7 6.9z",
    className: "concierge--exclamation_svg__st1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.6 31.2v7.1M101.5 34.2l4 5.1M123.7 34.2l-4 5.1",
    className: "concierge--exclamation_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 44.6c0 12.5 10.1 22.6 22.6 22.6 5.4 0 10.3-1.9 14.2-5h18.4L64 51.8c.8-2.3 1.2-4.7 1.2-7.2C65.2 32.1 55.1 22 42.6 22S20 32.1 20 44.6z",
    style: {
      fill: "#0185ff",
      stroke: "#fff",
      strokeWidth: 2,
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4 32.6H45v5.7l-1.2 10.4h-2.2l-1.2-10.4v-5.7zM42.7 55.5c1.3 0 2.3-1 2.3-2.3 0-1.3-1-2.3-2.3-2.3-1.3 0-2.3 1-2.3 2.3 0 1.3 1 2.3 2.3 2.3z",
    className: "concierge--exclamation_svg__st5"
  })));
};
export default SvgConciergeExclamation;